import { useEffect, useState } from 'react';

import { breakpoints } from '../utils/mediaQueries';

/**
 * Hook to detect if the current viewport is mobile/tablet
 * @param customBreakpoint - Optional custom breakpoint in pixels (default: lg breakpoint = 1200px)
 * Returns true for devices smaller than the breakpoint (phones and tablets, including iPad Air landscape)
 */
export const useIsMobile = (customBreakpoint?: number): boolean => {
  const breakpoint = customBreakpoint ?? breakpoints.lg;

  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < breakpoint;
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};
